function cleanUrl(url) {
  return url.replace(/{/g, "%7B").replace(/}/g, "%7D");
}

export default cleanUrl;
